import React, { useEffect } from 'react';
import OrderDetail from '../OrderDetail/OrderDetail';
import { trackingServicePurchaseEvent } from '../../Services/Tracking.service';

const OrderConfirmation = ({ title, text, order, extraText }) => {
  useEffect(() => {
    trackingServicePurchaseEvent(order);
  }, []);

  return (
    <div>
      {order && (
        <OrderDetail
          isConfirmation={true}
          order={order}
          confirmationTitle={title}
          confirmationText={text}
          confirmationExtraText={extraText}
        />
      )}
    </div>
  );
};

export default OrderConfirmation;
